<template>
  <BaseSimuladorIndicadorModal
    ref="baseModal"
    :modal-id="modalId"
    title="Simulador"
    numerador-label="Numerador"
    denominador-label="Denominador"
    :valor-numerador="nManual"
    :valor-denominador="dManual"
    :base-numerador="baseNumerador"
    :base-denominador="baseDenominador"
    :procedimentos-numerador="PROCEDIMENTOS_NUMERADOR"
    :procedimentos-denominador="PROCEDIMENTOS_DENOMINADOR"
    :tipos="TIPOS_CLASSIFICACAO"
    :calculate-result-fn="calcularResultado"
    :calculate-class-fn="calcularClasse"
    :apply-preset-fn="aplicarPreset"
    :format-delta-fn="formatDelta"
    :result-text-fn="montarTextoResultado"
    hint="💡 Os botões preenchem valores de exemplo. Ajuste manualmente pelos controles acima."
    @update:numerador="setNumerador"
    @update:denominador="setDenominador"
    card="pessoa-diabetes"
    :showModalCidsCiaps="true"
    :gruposCiap="['DIABETES']"
    :gruposCid="['DIABETES']"
    :gruposSigtap="['PA', 'ANTROP', 'PESO', 'ALTURA', 'DIABETES']"
  />
</template>

<script>
import BaseSimuladorIndicadorModal from '@/pages/IndicadoresAps/components/BaseSimuladorIndicadorModal.vue'

export default {
  name: 'SimuladorModal',
  components: {
    BaseSimuladorIndicadorModal,
  },
  props: {
    modalId: {
      type: String,
      default: 'simulador-modal',
    },
    dadosPercentualMunicipio: {
      type: Object,
      default: () => ({}),
    },
    dadosPercentualEquipe: {
      type: Object,
      default: () => ({}),
    },
    dadosPercentualMicroArea: {
      type: Object,
      default: () => ({}),
    },
    selectedEquipe: {
      type: [Object, String],
      default: '',
    },
    selectedMicroArea: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      nManual: 0,
      dManual: 1,
      baseNumerador: 0,
      baseDenominador: 1,
      TIPOS_CLASSIFICACAO: [
        { value: 'Ótimo', label: 'Ótimo', description: '> 75 e <= 100' },
        { value: 'Bom', label: 'Bom', description: '> 50 e <= 75' },
        {
          value: 'Suficiente',
          label: 'Suficiente',
          description: '> 25 e <= 50',
        },
        { value: 'Regular', label: 'Regular', description: '<= 25' },
      ],
      PROCEDIMENTOS_NUMERADOR: [
        {
          icon: null,
          codigo: null,
          desc: '01 (uma) consulta presencial ou remota realizadas por médica(o) ou enfermeira(o), nos últimos 06 (seis) meses.',
        },
        {
          icon: null,
          codigo: null,
          desc: '01 (um) registro de aferição de pressão arterial realizado nos últimos 06 (seis) meses.',
        },
        {
          icon: null,
          codigo: null,
          desc: '02 (duas) visitas domiciliares realizadas por ACS/TACS, com intervalo mínimo de 30 (trinta) dias, nos últimos 12 (doze) meses.',
        },
        {
          icon: null,
          codigo: null,
          desc: '01 (um) registro simultâneos de peso e altura realizado nos últimos 12 (doze) meses.',
        },
        {
          icon: null,
          codigo: null,
          desc: '01 (um) registro de solicitação de hemoglobina glicada realizada ou avaliada, nos últimos 12 (doze) meses.',
        },
        {
          icon: null,
          codigo: null,
          desc: '01 (uma) avaliação dos pés realizada nos últimos 12 (doze) meses.',
        },
      ],
      PROCEDIMENTOS_DENOMINADOR: [
        {
          icon: null,
          codigo: null,
          desc: 'Total de pessoas com diabetes vinculadas à equipe no período.',
        },
      ],
    }
  },
  methods: {
    open() {
      this.aplicarFonte()
      this.$refs.baseModal.open()
    },

    close() {
      this.$refs.baseModal.close()
    },

    aplicarFonte() {
      let fonte = this.dadosPercentualMunicipio

      if (this.selectedMicroArea) {
        fonte = this.dadosPercentualMicroArea
      } else if (this.selectedEquipe) {
        fonte = this.dadosPercentualEquipe
      }

      const numerador = Number(fonte?.numerador) || 0
      const denominador = Number(fonte?.denominador) || 1

      this.nManual = numerador
      this.dManual = denominador
      this.resetBase()
    },

    setNumerador(valor) {
      this.nManual = valor
    },

    setDenominador(valor) {
      this.dManual = valor
    },

    resetBase() {
      this.baseNumerador = this.nManual
      this.baseDenominador = this.dManual
    },

    calcularResultado({ numerador, denominador }) {
      const d = Number(denominador) || 0
      if (d <= 0) return 0

      const n = Number(numerador) || 0
      return Number((n / d).toFixed(2))
    },

    calcularClasse({ resultado }) {
      if (resultado > 100) {
        return { nivel: 'Ótimo', variant: 'primary' }
      }
      if (resultado > 75 && resultado <= 100) {
        return { nivel: 'Ótimo', variant: 'primary' }
      }
      if (resultado > 50 && resultado <= 75) {
        return { nivel: 'Bom', variant: 'success' }
      }
      if (resultado > 25 && resultado <= 50) {
        return { nivel: 'Suficiente', variant: 'warning' }
      }
      if (resultado <= 25) return { nivel: 'Regular', variant: 'danger' }

      return { nivel: 'Regular', variant: 'danger' }
    },

    aplicarPreset({ tipo, setNumerador, setDenominador }) {
      if (tipo === 'Ótimo') {
        setNumerador(7501)
        setDenominador(100)
      } else if (tipo === 'Bom') {
        setNumerador(5001)
        setDenominador(100)
      } else if (tipo === 'Suficiente') {
        setNumerador(2501)
        setDenominador(100)
      } else {
        setNumerador(2500)
        setDenominador(100)
      }

      this.$nextTick(() => {
        this.resetBase()
      })
    },

    formatDelta(val) {
      if (val > 0) return `+${val}`
      if (val < 0) return `${val}`
      return ''
    },

    montarTextoResultado({ resultado }) {
      return ``
    },
  },
}
</script>
